module.exports = __webpack_public_path__ + "static/media/edit.0b458d7a.svg";